'use strict';

function createBiSession(metaSiteId, viewerSessionId, ownerId) {
  return {
    get metaSiteId() {
      return metaSiteId;
    },
    get viewerSessionId() {
      return viewerSessionId;
    },
    get ownerId() {
      return ownerId;
    }
  };
}

module.exports = {
  createBiSession: createBiSession
};



// WEBPACK FOOTER //
// ./src/main/biUtils.js